module.exports = __webpack_public_path__ + "img/crunchyroll.730d86f.jpg";